class SystemGroupSystemsDatatable {
    constructor(systemGroupID = null, numberOfSystems = 0, systemDatatable, modal){
        let organizationID = new URLSearchParams(window.location.search).get('organizationID');
        this.organizationID = organizationID;
        this.systemGroupID = systemGroupID;
        this.numberOfSystems = numberOfSystems;
        this.modal = modal;
        this.datatable = this.init(systemDatatable);
        this.initActions(organizationID);
    }
    init(systemDatatable){
        const thisClass = this;
        let data = {
            organizationID: thisClass.organizationID
        }
        if(this.systemGroupID){
            data.systemGroupID = this.systemGroupID;
        }
        let datatableEl = $(systemDatatable);
        if ($.fn.DataTable.isDataTable(systemDatatable)) {
            datatableEl.DataTable().destroy();
        }
        let datatable = datatableEl.DataTable({
            searchDelay: 500,
            processing: false,
            serverSide: false,
            stateSave: false,
            sortable: false,
            info: false,
            ordering: false,
            paging: false,
            ajax: {
                url: '/systems/?do=getSystemGroupSystems',
                type: 'POST',
                data: data
            },
            select: {
                style: 'multi',
                selector: 'td:first-child input[type="checkbox"]',
                className: ''
            },
            language: {
                emptyTable:
                    "<div class='text-center min-h-200px d-flex flex-center flex-column'>" +
                    "   <i class=\"fa-solid fa-server fs-5hx ga-text-primary-500 mb-5\" aria-hidden=\"true\"></i>\n" +
                    "   <p class=\"text-primary fs-7 text-center mb-0\">\n" +
                    "       Your Team has no Systems. \n" +
                    "   </p>" +
                    "</div>",
                loadingRecords: ""
            },
            drawCallback: function (settings) {
                // Init all popovers after datatable draw
                const popoverTriggerList = [].slice.call(thisClass.modal.querySelectorAll('#system-group-systems-datatable [data-bs-toggle="popover"]'));
                popoverTriggerList.map(function (popoverTriggerEl) {
                    new bootstrap.Popover(popoverTriggerEl);
                });
                /** Remove header of table */
                $(thisClass.modal).find("#system-group-systems-datatable_wrapper .dataTables_scrollHead, #system-group-systems-datatable_wrapper thead").hide();

                /** Set rows to section (systems) */
                const api = this.api();
                const rows = api.rows({
                    page: "current"
                }).nodes();
                if (rows.length > 0) {
                    $(rows).eq(0).before(
                        "<tr class=\"section fs-5 fw-bolder border-0\" data-section-name=\"systems\">" +
                        "   <td class=\"py-1 d-none\"></td>" +
                        "   <td class=\"py-1\"> Systems" +
                        "       <span class=\"badge badge-sm badge-light-primary align-middle ms-1\">" +
                        "           <span id=\"system_group_systems_selected\">" + thisClass.numberOfSystems + "</span>" +
                        "       </span>" +
                        "   </td>" +
                        "   <td class=\"py-1 text-end\">" +
                        "       <span class=\"text-decoration-underline-ga text-danger danger fs-7 remove-all-systems-from-group\">Remove All</span>" +
                        "   </td>" +
                        "</tr>"
                    );
                }
            },
            createdRow: function (row, data) {
                if (!data.checked) {
                    $(row).addClass('d-none not-in-group');
                }
            },
            columns: [
                {
                    data: 'uuid',
                    className: 'py-2 d-none',
                    sortable: false,
                    render: function (data, type, row) {
                        return '<div class="form-check form-check-sm form-check-custom form-check-solid ga-border-primary-200 mx-3">' +
                            '    <input class="form-check-input cursor-pointer" type="checkbox" name="systems[]" value="' + row['uuid'] + '" ' + (row['checked'] ? 'checked' : '') + '/>' +
                            '</div>';
                    }
                },
                {
                    data: 'name',
                    title: 'System',
                    sortable: false,
                    className: 'min-w-120px',
                    render: function (data, type, row) {
                        let iconUrl = '/media/goodaccess/icons/system/'+row['iconID']+'.svg';
                        let serviceHtml = '';
                        if(row['isAdvanced'] && row['services']){
                            serviceHtml = new ServiceTooltip().getHtml(row['services']);
                        }

                        return '<div class="d-flex align-items-center" data-cy="system-card">' +
                            '       <div class="symbol symbol-40px me-3 border ga-border-primary-300 symbol-circle">' +
                            '           <div class="symbol-label bg-light-primary border border-2 border-white'+(!row['isValid'] || row['isIsolated'] ? ' filter-grayscale' : '')+'">' +
                            '               <img src="'+iconUrl+'" alt="icon" class="h-40px">' +
                            '           </div>' +
                            (serviceHtml !== '' ? '<span class="symbol-badge badge badge-circle bg-primary start-85 top-85 w-15px h-15px fs-10 text-center text-white" data-bs-toggle="popover" data-bs-placement="top" data-bs-trigger="hover" data-bs-html="true" data-bs-content="'+serviceHtml+'">'+row['services'].length+'</span>' : '')+
                            (!row['isValid'] ? '<span class="symbol-badge badge badge-circle bg-danger start-85 top-85 w-15px h-15px fs-9 text-center text-white" data-bs-toggle="popover" data-bs-placement="top" data-bs-trigger="hover" data-bs-html="true" data-bs-content="<div class=\'fw-bold\'>Invalid</div>">&#33;</span>' : '') +
                            (row['isIsolated'] ? '<span class="symbol-badge badge badge-circle bg-danger start-85 top-85 w-15px h-15px fs-10 text-center text-white" data-bs-toggle="popover" data-bs-placement="top" data-bs-trigger="hover" data-bs-html="true" data-bs-content="<div class=\'fw-bold\'>Isolated</div>">&#10005;</span>' : '') +
                            '       </div>' +
                            '       <div class="d-flex justify-content-start flex-column">' +
                            '           <div data-cy="system-id" id="'+row['uuid']+'"><span class="fw-bold text-decoration-underline-ga primary text-primary mb-1 fs-6 '+ (row['edit'] ? 'edit-system' : '') +'" data-system-name="'+row['name']+'">'+row['name']+'</span>'+
                            (row['isIcmpProtocolEnabled'] ? '<span class="ms-2 fst-italic fs-9 badge badge-sm badge-warning py-1" data-bs-toggle="popover" data-bs-placement="top" data-bs-trigger="hover" data-bs-html="true" data-bs-content="<div class=\'text-center\'>ICMP protocol enabled</div>">ICMP</span>' : '')+
                            (row['customUri'] ? '' : '<i class="fa-solid fa-eye-slash ga-text-primary-700 ms-2" data-bs-toggle="popover" data-bs-placement="top" data-bs-trigger="hover" data-bs-html="true" data-bs-content="<div class=\'text-center\'>Not visible as a System Shortcut in GoodAccess Client Application.</div>"></i>') +'</div>' +
                            '           <span class="fw-semibold d-block fs-7 ga-text-primary-800">'+(row['customUri'] ?? row['host'])+'</span>' +
                            '       </div>' +
                            '   </div>';
                    }
                },
                {
                    data: null,
                    title: 'Action',
                    sortable: false,
                    className: 'text-end',
                    render: function (data, type, row) {
                        return '<span class="text-decoration-underline-ga text-danger danger fs-7 remove-system-from-group">Remove</span>';
                    }
                }
            ]
        }).on('init.dt', function () {
            if(datatable.page.info().recordsTotal === 0){
                $(thisClass.modal).find('div[data-kt-docs-table-toolbar="base"]').addClass('d-none');
            } else {
                let numberOfSelectedSystems = $(thisClass.modal).find('#system-group-systems-datatable tbody tr:not(.not-in-group, .d-none, .section)').length;
                if (numberOfSelectedSystems === 0) {
                    $(thisClass.modal).find('#system-group-systems-datatable_wrapper').hide();
                    $(thisClass.modal).find('#system-group-systems-datatable_no-results').addClass('d-flex flex-center flex-column').removeClass('d-none');
                    $(thisClass.modal).find('#system-group-systems-datatable_wrapper [data-kt-docs-table-filter="search-parent"]').addClass('d-none');
                }
            }
        });
        return datatable;
    }
    initActions(){
        const thisClass = this;
        /** Search */
        let timer;
        const input = thisClass.modal.querySelector('input[data-kt-docs-table-filter=search]');
        if(input){
            input.addEventListener('keyup', function (e) {
                clearTimeout(timer);
                timer = setTimeout(() => {
                    thisClass.searchDatatable(this.value.toLowerCase());
                }, 300);
            });
        }
    }
    searchDatatable(value) {
        /** Search only visible (selected) systems */
        let data = this.datatable.rows().data().toArray();
        let systemsInSystemGroup = 0;
        for(let i in data){
            let node = $(this.datatable.row(i).node());
            if(!node.hasClass('not-in-group')){
                if(value === '' || this.includeValue(data[i].name, value) || this.includeValue(data[i].host, value)){
                    node.removeClass('d-none');
                    systemsInSystemGroup++;
                } else {
                    node.addClass('d-none');
                }
            }
        }

        if(systemsInSystemGroup === 0){
            $(this.modal).find('#system-group-systems-datatable_wrapper [data-section-name="systems"]').addClass('d-none');
            $(this.modal).find('#system-group-systems-datatable_no-search-results').removeClass('d-none');
        } else {
            $(this.modal).find('#system-group-systems-datatable_wrapper [data-section-name="systems"]').removeClass('d-none');
            $(this.modal).find('#system-group-systems-datatable_no-search-results').addClass('d-none');
        }
    }
    includeValue(value, search) {
        if(value !== '' && value !== null){
            return value.toLowerCase().includes(search);
        }
        return false;
    }
    resetDatatable(){
        let addSystemsToSystemGroupButton = this.modal.querySelector('#addSystemsToSystemGroup');
        addSystemsToSystemGroupButton.removeAttribute('disabled');
        
        let systemsInSystemGroup = this.datatable.rows(':not(.not-in-group.d-none)').data().toArray();
        for(let i in systemsInSystemGroup){
            let node = $(this.datatable.row(i).node());
            node.find('input[name=systems\\[\\]]').prop('checked', false);
            node.addClass('d-none not-in-group');
        }

        let jQueryModal = $(this.modal);
        jQueryModal.find('#system-group-systems-datatable_wrapper').hide();
        jQueryModal.find('#system-group-systems-datatable_no-results').addClass('d-flex flex-center flex-column').removeClass('d-none');
    }
}
window.SystemGroupSystemsDatatable = SystemGroupSystemsDatatable;